<div class="vex-user-menu">
  <!-- Current Workspace Display (switching happens via the top bar) -->
  @if (workspaces().length > 0) {
    <div class="px-3 py-3 border-b border-divider">
      <!-- No Workspace Selected -->
      @if (!currentWorkspaceId()) {
        <div class="workspace-display workspace-display--empty">
          <div class="workspace-display__content">
            <div
              class="workspace-display__indicator"
              style="background-color: #ef4444">
              <mat-icon class="text-white" svgIcon="mat:workspaces"></mat-icon>
            </div>
            <div class="workspace-display__info">
              <div class="workspace-display__name font-semibold">
                {{ "shared.workspace.select" | translate }}
              </div>
              <div class="workspace-display__role text-red-600">
                {{ "shared.workspace.useTopBarToSwitch" | translate }}
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Workspace Selected - Show Current -->
      @if (currentWorkspaceId()) {
        <div class="workspace-display">
          <div class="workspace-display__content">
            <div
              class="workspace-display__indicator"
              [style.background-color]="
                getWorkspaceColor(getCurrentWorkspace())
              ">
              <span class="workspace-display__initials">{{
                getWorkspaceInitials(getCurrentWorkspace())
              }}</span>
            </div>
            <div class="workspace-display__info">
              <div class="workspace-display__name">
                {{ getCurrentWorkspaceName() }}
              </div>
              <div class="workspace-display__role">
                {{
                  $safeNavigationMigration(getCurrentWorkspace()?.role)
                    | titlecase
                }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Workspace section (only for admin/owner): the two settings pages that
       belong to the space — the page of settings, and the cockpit inbox, which
       stays its own screen. Navigation lives here, never inside the pages. -->
  @if (canManageWorkspace()) {
    <div class="vex-user-menu-section">
      <div
        class="vex-user-menu-section__header px-4 pt-2 pb-1 text-xs font-semibold text-secondary">
        {{ "shared.workspace.title" | translate }}
      </div>
      <a
        (click)="close()"
        (keydown.enter)="close()"
        [routerLink]="['/apps/workspace/settings']"
        data-testid="user-menu-workspace-settings"
        class="vex-user-menu-item"
        matRipple
        matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
        <mat-icon
          class="vex-user-menu-item__icon icon-sm"
          svgIcon="mat:business"></mat-icon>
        <div class="vex-user-menu-item__label">
          {{ "shared.userMenu.workspaceSettings" | translate }}
        </div>
      </a>
      <a
        (click)="close()"
        (keydown.enter)="close()"
        [routerLink]="['/apps/workspace/settings/inbox']"
        data-testid="user-menu-cockpit-inbox"
        class="vex-user-menu-item"
        matRipple
        matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
        <mat-icon
          class="vex-user-menu-item__icon icon-sm"
          svgIcon="mat:inbox"></mat-icon>
        <div class="vex-user-menu-item__label">
          {{ "shared.contextual.workspace.inbox" | translate }}
        </div>
      </a>
    </div>
    <div class="border-b border-divider mx-4"></div>
  }

  <!-- Account Settings Section -->
  <div class="vex-user-menu-section">
    <div
      class="vex-user-menu-section__header px-4 pt-2 pb-1 text-xs font-semibold text-secondary">
      {{ "shared.account.settings" | translate }}
    </div>

    <a
      (click)="close()"
      (keydown.enter)="close()"
      [routerLink]="['/apps/user-profile']"
      data-testid="user-menu-account-settings"
      class="vex-user-menu-item"
      matRipple
      matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
      <mat-icon
        class="vex-user-menu-item__icon icon-sm"
        svgIcon="mat:account_circle"></mat-icon>
      <div class="vex-user-menu-item__label">
        {{ "shared.userMenu.accountSettings" | translate }}
      </div>
    </a>
  </div>

  <div class="border-b border-divider mx-4"></div>

  <!-- Help & Support section -->
  <div class="vex-user-menu-section">
    <div
      class="vex-user-menu-section__header px-4 pt-2 pb-1 text-xs font-semibold text-secondary">
      {{ "shared.help.title" | translate }}
    </div>

    <a
      (click)="close()"
      (keydown.enter)="close()"
      [routerLink]="['/help/guide']"
      class="vex-user-menu-item"
      matRipple
      matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
      <mat-icon
        class="vex-user-menu-item__icon icon-sm"
        svgIcon="mat:help_center"></mat-icon>
      <div class="vex-user-menu-item__label">
        {{ "shared.help.resources" | translate }}
      </div>
    </a>
  </div>

  <!-- Global Admin section - Only shown to superadmins -->
  @if (isSuperAdmin()) {
    <div class="border-b border-divider mx-4"></div>
    <a
      (click)="close()"
      (keydown.enter)="close()"
      [routerLink]="['/superadmin']"
      class="vex-user-menu-item vex-user-menu-item--admin"
      matRipple
      matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
      <mat-icon
        class="vex-user-menu-item__icon icon-sm"
        svgIcon="mat:admin_panel_settings"></mat-icon>
      <div class="vex-user-menu-item__label">
        {{ "shared.admin.globalAdmin" | translate }}
      </div>
    </a>
  }

  <div class="border-b border-divider mx-4"></div>

  <a
    (click)="logout()"
    (keydown.enter)="logout()"
    tabindex="0"
    class="vex-user-menu-item vex-user-menu-item--danger"
    matRipple
    matRippleColor="rgb(var(--vex-color-primary-600), 0.1)">
    <mat-icon
      class="vex-user-menu-item__icon icon-sm"
      svgIcon="mat:logout"></mat-icon>
    <div class="vex-user-menu-item__label">
      {{ "shared.navigation.signOut" | translate }}
    </div>
  </a>
</div>
